// ----------------------------------------------------------------------
// <copyright file="Izenda.PreviewRecord.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React, { PropTypes } from 'react';
import { observer, propTypes as MobxPropTypes } from 'mobx-react';
import EventUtils, { notifyChange } from 'EventUtils';
import { NUMBER_OF_RECORD_LIMIT_CONSTRAINT } from 'logic/data/Izenda.ReportBodyConstants';
import Input from 'share/components/controls/Izenda.Input';
import Validator from 'share/components/hoc/Izenda.Validator';
import localizer from 'share/localization/Izenda.Localizer';
const ValidatableInput = Validator()(Input);
import { isNil } from 'lodash/fp';
const PreviewRecord = observer(
  ({
    dashboardPart,
    dashboardPart: { reportPart, showNumberOfRecord, numberOfRecordDisplayValue, setNumberOfRecord },
    onUpdateData
  }) => {
    if (!showNumberOfRecord) {
      return null;
    }

    var onBlur = function() {
      onUpdateData();
    };
    var onKeyDown = function(e) {
      if (e.keyCode === 13) {
        onUpdateData();
      }
    };

    return (
      <span className="u_inlineBlock">
        <label htmlFor="record">{localizer.getText('DASHBOARD_LABEL_NUMBER_OF_RECORDS')}</label>
        <ValidatableInput
          containerClassName="u_inlineBlock u_alignMiddle"
          className="form-control"
          disabled={isNil(reportPart)}
          validations={NUMBER_OF_RECORD_LIMIT_CONSTRAINT}
          field="record"
          value={numberOfRecordDisplayValue}
          onChange={notifyChange(setNumberOfRecord.bind(dashboardPart), EventUtils.INPUT)}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
        />
      </span>
    );
  }
);

PreviewRecord.propTypes = {
  dashboardPart: MobxPropTypes.observableObject.isRequired,
  onUpdateData: PropTypes.func
};

export default PreviewRecord;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.PreviewRecord.js